<template>
  <div class="project-container">
    <div class="header-section">
      <div class="Pr animated-title">
        <span v-for="(char, index) in 'Projects'.split('')" :key="index" 
              :style="{animationDelay: index * 0.1 + 's'}" class="char">{{ char }}</span>
      </div>
      <div class="subtitle">Explore Our Creative Collection</div>
      <div class="decorative-elements">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
        <div class="circle circle-3"></div>
      </div>
    </div>
    <projects class="projects-fade-in"/>
    <router-link to="/about"><div class="Flip1"></div></router-link>
  </div>
</template>

<script>
import Projects from '@/components/Projects.vue';
export default {
  name :'project',
  components: { Projects },
  

};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro");

@keyframes charFadeIn {
  from {
    opacity: 0;
    transform: translateY(-30px) rotateX(90deg);
  }
  to {
    opacity: 1;
    transform: translateY(0) rotateX(0);
  }
}

@keyframes projectsFadeIn {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes subtitleFade {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-20px) scale(1.1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.project-container {
  animation: projectsFadeIn 0.8s ease-out;
  position: relative;
  min-height: 100vh;
}

.header-section {
  position: relative;
  padding: 40px 20px 20px;
  text-align: center;
  overflow: hidden;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: 
    linear-gradient(135deg, 
      rgba(93, 78, 55, 0.15) 0%,
      rgba(61, 47, 35, 0.1) 100%);
  border-bottom: 2px solid rgba(212, 175, 55, 0.2);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.animated-title .char {
  display: inline-block;
  animation: charFadeIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
  opacity: 0;
}

.projects-fade-in {
  animation: projectsFadeIn 1s ease-out 0.5s backwards;
}

@font-face {
  font-family: 'Lovtony';
  src: url('../assets/LovtonyScript.ttf');
}

.Pr {
  font-size: clamp(60px, 12vw, 120px);
  font-family: 'Lovtony', cursive;
  font-weight: 400;
  color: #3d5a80;
  text-shadow: 
    0 2px 4px rgba(0, 0, 0, 0.4),
    0 0 10px rgba(61, 90, 128, 0.2);
  letter-spacing: 0.05em;
  position: relative;
  z-index: 2;
  margin-bottom: 10px;
  text-transform: none;
}

@keyframes gradientShift {
  0%, 100% {
    text-shadow: 
      0 3px 8px rgba(0, 0, 0, 0.8),
      0 0 20px rgba(212, 175, 55, 0.4),
      2px 2px 0 #8b7355,
      3px 3px 0 #5d4e37;
  }
  50% {
    text-shadow: 
      0 3px 8px rgba(0, 0, 0, 0.8),
      0 0 30px rgba(212, 175, 55, 0.6),
      2px 2px 0 #8b7355,
      3px 3px 0 #5d4e37;
  }
}

@font-face {
  font-family: 'Quarrel';
  src: url('../assets/LoversQuarrel-Regular.ttf');
}

.subtitle {
  font-family: 'Quarrel', cursive;
  font-size: clamp(16px, 2.5vw, 24px);
  color: rgba(139, 69, 69, 0.8);
  letter-spacing: 0.05em;
  text-transform: none;
  animation: subtitleFade 1s ease-out 0.8s backwards;
  font-weight: 400;
  font-style: normal;
  position: relative;
  z-index: 2;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.decorative-elements {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
}

.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.08;
  background: radial-gradient(circle, rgba(93, 78, 55, 0.4) 0%, rgba(61, 47, 35, 0.2) 100%);
}

.circle-1 {
  width: 300px;
  height: 300px;
  top: -100px;
  right: -50px;
  animation: float 6s ease-in-out infinite, rotate 20s linear infinite;
  border: 2px solid rgba(212, 175, 55, 0.1);
}

.circle-2 {
  width: 200px;
  height: 200px;
  bottom: -50px;
  left: -30px;
  animation: float 8s ease-in-out infinite 1s, rotate 25s linear infinite reverse;
  border: 2px solid rgba(212, 175, 55, 0.1);
}

.circle-3 {
  width: 150px;
  height: 150px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: float 7s ease-in-out infinite 0.5s;
  border: 2px solid rgba(212, 175, 55, 0.1);
}
</style>

<style scoped>
@font-face {
  font-family: rawless;
  src: url(../assets/Rawless.ttf);
}

div .Flip1 {
  position: fixed;
  background-image: url("../../public/layerFlip.png");
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 200;
  width: 70px;
  height: 70px;
  left: 0%;
  top: 0%;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  touch-action: manipulation;
  filter: 
    drop-shadow(0 3px 10px rgba(61, 90, 128, 0.4))
    brightness(0.9)
    saturate(0.8);
}

div .Flip1:hover,
div .Flip1:active {
  filter: 
    drop-shadow(0 5px 20px rgba(61, 90, 128, 0.6))
    brightness(1.1)
    saturate(1.2);
  transform: scale(1.15) rotate(-10deg);
}

div .Pr {
  font-family: rawless;
  font-size: 40px;
  padding: 20px;
  margin-top: 20px;
}

/* Tablet */
@media (max-width: 1024px) {
  div .Flip1 {
    width: 60px;
    height: 60px;
  }
  
  div .Pr {
    font-size: 36px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  div .Flip1 {
    width: 50px;
    height: 50px;
  }
  
  div .Pr {
    font-size: 32px;
    padding: 15px;
    margin-top: 15px;
  }
}

@media (max-width: 480px) {
  div .Flip1 {
    width: 45px;
    height: 45px;
    left: 3%;
    top: 3%;
  }
  
  div .Pr {
    font-size: 28px;
    padding: 10px;
    margin-top: 10px;
  }
}
</style>